interface IconProps {
  color?: string;
  className?: string;
}

export default function GeneralInformationIcon({
  color = "#8E929E",
  className = "",
}: IconProps) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="23.5321"
        height="23.5321"
        rx="4.5"
        fill="none"
      />
      <rect
        x="0.5"
        y="0.5"
        width="23.5321"
        height="23.5321"
        rx="4.5"
        stroke={color}
      />
      <g clipPath="url(#clip0_6675_62261)">
        <path
          d="M7.21114 18.2451C7.10057 18.1879 7.00861 18.1327 6.96728 18.008L6.95074 10.1287L7.00758 9.95086C7.75362 9.19637 8.49552 8.42655 9.2829 7.71806L9.41723 7.68739L12.8374 7.68432C13.0679 7.29072 13.3355 6.94517 13.723 6.69265C14.9423 5.89624 16.5883 6.3062 17.2796 7.57084C18.1104 9.09414 17.1349 10.9088 15.4486 11.1818L15.4341 18.0059C15.3928 18.1317 15.3008 18.1858 15.1903 18.2431H7.21114V18.2451ZM14.9485 6.99526C12.6535 7.18338 12.9118 10.6256 15.2006 10.4907C17.5369 10.3526 17.2992 6.80204 14.9485 6.99526ZM12.6401 8.38974H9.78405V10.2228C9.78405 10.3046 9.59495 10.4917 9.51229 10.4917H7.65959V17.5448H14.7408V11.1695C13.4089 10.9947 12.4252 9.71163 12.6401 8.39076V8.38974ZM9.07624 9.79138V8.90398L8.17934 9.79138H9.07624Z"
          fill={color}
        />
        <path
          d="M9.35315 11.8987L13.0059 11.8926C13.3799 11.9345 13.444 12.4283 13.1009 12.5714C11.8403 12.6082 10.558 12.6082 9.29838 12.5714C8.97703 12.4406 9.00596 11.9703 9.35212 11.8987H9.35315Z"
          fill={color}
        />
        <path
          d="M9.35315 13.3006L13.0059 13.2944C13.3799 13.3363 13.444 13.8301 13.1009 13.9733C11.8403 14.0101 10.558 14.0101 9.29838 13.9733C8.97703 13.8424 9.00596 13.3721 9.35212 13.3006H9.35315Z"
          fill={color}
        />
        <path
          d="M9.35315 14.7019L13.0059 14.6958C13.3799 14.7377 13.444 15.2315 13.1009 15.3746C11.8403 15.4114 10.558 15.4114 9.29838 15.3746C8.97703 15.2438 9.00596 14.7735 9.35212 14.7019H9.35315Z"
          fill={color}
        />
        <path
          d="M15.0188 8.39636C15.2368 8.3616 15.4248 8.48735 15.4496 8.70613C15.4744 8.92491 15.4806 9.67327 15.4445 9.86853C15.3763 10.2396 14.7894 10.2396 14.7418 9.82764C14.716 9.60579 14.7119 8.87584 14.748 8.66524C14.7708 8.53233 14.8824 8.41885 15.0198 8.39636H15.0188Z"
          fill={color}
        />
        <path
          d="M15.0191 7.34539C15.523 7.26452 15.5964 7.96062 15.1732 8.03535C14.6787 8.12338 14.5866 7.41398 15.0191 7.34539Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_6675_62261">
          <rect
            width="10.6306"
            height="11.9594"
            fill="white"
            transform="translate(6.95074 6.28613)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
